<div class="style-flex mt-5">
  <div class="m-auto" style="width: 500px">
    <nk-card>
      <nk-card-content>
        <div class="p-2">
          <div class="mb-5">
            <img src="app/assets/img/logo_black.svg" class="animated fadeIn mb-4" height="19" />
            <h2 [innerHtml]="'sign_up.thanks_for_applying_for_sign_up' | translate: { customerName: companyName }"></h2>
          </div>
        </div>
        <div class="text-center">
          <p class="colorize text primary"><i class="fas fa-paper-plane fa-3x"></i></p>
          <p>
            {{ 'sign_up.your_organization_already_has_an_account' | translate }}
          </p>
          <p>
            <a routerLink="/" nkButton color="secondary">
              <i class="fa fa-arrow-left me-2"></i> {{ 'sign_up.success.back_to_login' | translate }}</a
            >
          </p>
          <p class="text-muted mt-5" [innerHtml]="'sign_up.something_went_wrong_help' | translate"></p>
        </div>
      </nk-card-content>
    </nk-card>
  </div>
</div>
